import { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { FormPedidosCompra } from '../../components/Forms/FormPedidosCompra'
import PedidosCompraService from '../../services/database/PedidosCompraService'
import { toast } from 'react-toastify'

export function NovoPedidoCompra() {
  const [isLoadingRequest, setIsLoadingRequest] = useState(false)

  const formPedidosCompraRef = useRef(null)

  const navigate = useNavigate()

  async function handleSubmit() {
    try {
      setIsLoadingRequest(true)

      if (formPedidosCompraRef.current) {
        const { order, products, duplicatas } =
          formPedidosCompraRef?.current?.getDataForm()

        const idPedidoCompra = await PedidosCompraService.create({
          order,
          products,
          duplicatas,
        })

        toast.success(`Pedido de compra criado com sucesso!`)
        navigate(`/pedidos-compra/${idPedidoCompra}`)
      }
    } catch (err) {
      console.log(`Erro ao criar o pedido de compra: ${err}`)

      toast.error(`Não foi possível criar o pedido de compra!`)
    } finally {
      setIsLoadingRequest(false)
    }
  }

  return (
    <FormPedidosCompra
      ref={formPedidosCompraRef}
      title="Novo Pedido de Compra"
      onSubmit={handleSubmit}
      isLoadingRequest={isLoadingRequest}
    />
  )
}
